module.exports = __webpack_public_path__ + "media/images/icons/platform-1a425cdafd6fad5721196b3352add49c.png";